import { useState } from "react";
import { Check, X } from "lucide-react";

const KEY = "ss-coach-steps-hidden";

export const FirstSteps = ({ teams }) => {
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");
  if (hidden) return null;
  const first = teams[0];
  const hasPlayers = teams.some((t) => t.players > 0);
  const steps = [
    ["Create your first squad", "Use the box under My squads below.", teams.length > 0, null],
    ["Set the club look", "Open the squad and design one shield – background, colours, crest.", hasPlayers, first && `/team/${first.id}`],
    ["Share the parent link", "Copy the link from the squad page into your team WhatsApp.", false, first && `/team/${first.id}`],
    ["Watch shields come in", "You'll get an update here and by email as each parent finishes.", false, null],
  ];
  const hide = () => { localStorage.setItem(KEY, "1"); setHidden(true); };
  return (
    <section className="relative border-2 border-slate-900 bg-slate-900 p-5 text-white shadow-[6px_6px_0_0_#a3e635]" data-testid="coach-first-steps">
      <button type="button" onClick={hide} aria-label="Hide first steps" className="absolute right-3 top-3 text-slate-400 hover:text-white" data-testid="coach-first-steps-hide"><X className="h-4 w-4" /></button>
      <h2 className="font-display text-lg font-extrabold uppercase">First steps</h2>
      <p className="text-sm text-slate-300">Free for your club · parents pay per shield · printed in Ireland, delivered in 7–10 working days.</p>
      <ol className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {steps.map(([t, d, done, href], i) => {
          const body = (
            <>
              <span className={`flex h-7 w-7 shrink-0 items-center justify-center text-sm font-bold ${done ? "bg-lime-400 text-slate-900" : "border-2 border-slate-600 text-slate-300"}`}>{done ? <Check className="h-4 w-4" /> : i + 1}</span>
              <span><span className={`block font-bold ${done ? "text-slate-400 line-through" : ""}`}>{t}</span><span className="text-xs text-slate-400">{d}</span></span>
            </>
          );
          return <li key={t} data-testid={`coach-first-step-${i + 1}`} data-done={done}>
            {href ? <a href={href} className="flex gap-3 hover:text-lime-300">{body}</a> : <div className="flex gap-3">{body}</div>}
          </li>;
        })}
      </ol>
    </section>
  );
};
